import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=d1b7bd1e&"
import script from "./Kpi.vue?vue&type=script&lang=js&"
export * from "./Kpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d1b7bd1e', component.options)
    } else {
      api.reload('d1b7bd1e', component.options)
    }
    module.hot.accept("./Kpi.vue?vue&type=template&id=d1b7bd1e&", function () {
      api.rerender('d1b7bd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Kpi/Kpi.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Kpi/Kpi.vue
// module id = J0qP
// module chunks = 0